module.exports = __webpack_public_path__ + "media/HROOFSHOWREEL.mp4";